import React from 'react';
import {
  UPDATE,
} from 'admin-on-rest';
import {
  FlatButton,
  SelectField,
  MenuItem,
} from 'material-ui';
import Datasheet from 'react-datasheet';
import 'react-datasheet/lib/react-datasheet.css';
import { set, get, range, has, isArray, flatten } from 'lodash';
import fileDownload from 'js-file-download';
import parseXml from '@rgrove/parse-xml';
// import xmljs from 'xml-js';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
// import utf8 from 'utf8';
// import he from 'he';

// import { kunal } from '../../client';
// import kunalClient from '../../client/kunalClient';
import { callApi } from '../../client/apiToolbox';
import '../styles.css';
import './styles.css';
import { js2xml, js2xliff } from '../utils/translationParser';
import ExportComponent from './ExportComponent';
import { isSuperUser } from '../../utils/permissionsUtils';
import { restClient } from '../../App';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
// const restClient = kunalClient(API_BASE_URL, kunal);

const styles = {
  buttonParent: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  pageButtonParent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
};

export const splitPlatform = (identifier) => {
  const formattedIdentifier = identifier.split(/-(.+)/, 2);
  if (formattedIdentifier.length > 1) {
    return formattedIdentifier.slice(1).join('');
  }
  return formattedIdentifier.join('');
};

const TranslationComponent = class extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      header: [
        { value: '', readOnly: true, width: 30 },
      ],
      resource: {},
      disabledImport: true,
      selectedLanguage: '',
      fileName: '',
      showColumn: false,
      toggleIdentifier: 'toggleIdentifier',
      toggleComments: 'toggleComments',
      toggleTranslatable: 'toggleTranslatable',
      checked: false,
      pageStart: 0,
      pageSize: 50,
      currentPage: 1,
      referenceLanguage: 'en',
    };
  }

  componentWillMount = () => {
    const resource = {};

    const filterFn = this.props.filter ? (item) => item[Object.keys(this.props.filter)[0]] === this.props.filter[Object.keys(this.props.filter)[0]] : (item) => !!item;

    range(0, this.props.choices[this.props.resource].filter(filterFn).length).forEach((id, i) => {
      resource[id] = this.props.choices[this.props.resource].filter(filterFn)[i];
    });

    const asArray = range(0, this.props.choices[this.props.resource]
      .filter(filterFn).length)
      .map((id) => resource[id]).sort((a, b) => {
        if (get(a, 'identifier')) {
          if (splitPlatform(a.identifier) > splitPlatform(b.identifier)) {
            return 1;
          }
          return -1;
        }
        return 1;
      });
    asArray.forEach((item, i) => resource[i] = item); // eslint-disable-line no-return-assign

    const { user: { languages }, property, showTitle, translate } = this.props;
    const properties = languages.map((lang) => ({
      value: `${property}-${lang}`,
      readOnly: true,
    }));
    const title = showTitle ? [{ value: translate('resources.products.fields.title'), readOnly: true }] : [];

    this.setState({
      resource,
      itemCount: this.props.choices[this.props.resource].filter(filterFn).length,
      totalPages: Math.ceil(this.props.choices[this.props.resource].filter(filterFn).length / this.state.pageSize),
      header: [
        ...this.state.header,
        ...title,
        {
          value: 'identifier',
          readOnly: true,
        },
        {
          value: 'translatable',
          readOnly: true,
          className: this.props.user.superUser ? '' : 'hideTranslatables',
        },
        {
          value: 'comments',
          readOnly: true,
        },
        {
          value: 'reference',
          readOnly: true,
        },
        ...properties,

      ],
    });
    // if (this.props.choices[this.props.resource].length === 0 && nextProps.choices[this.props.resource].length > 0) {
    // }
  }

  onLanguageChangeCb = (language) => this.setState({ fileName: '', selectedLanguage: language, disabledImport: true });

  formatAndSort = (data) => data.map((item) => ({ ...item, identifier: splitPlatform(item.identifier) })).sort((a, b) => a.identifier > b.identifier ? 1 : -1);

  exportPhrases = (language) => {
    const { platform } = this.props.filter;
    callApi(`${API_BASE_URL}/utils/phrases/export/${platform}`, 'GET')
      .then((data) => {
        if (platform === 'android') {
          const sortedResult = data.json.sort((a, b) => splitPlatform(a.identifier) > splitPlatform(b.identifier) ? 1 : -1);
          const xml = js2xml(sortedResult, language);
          fileDownload(xml, `${platform}-${language}.xml`);
          return;
        }

        if (platform === 'ios') {
          const xliff = js2xliff(data.json, language);
          fileDownload(xliff, `${platform}-${language}.xliff`);
          return;
        }

        const sortedAndFormatted = this.formatAndSort(data.json);
        const json = {};
        sortedAndFormatted.forEach((translation) => json[translation.identifier] = translation.translations.find((trans) => trans.lang === language).content); // eslint-disable-line 
        fileDownload(JSON.stringify(json), `translations-${language}.json`);
      })
      .catch((e) => console.log('Export Phrase Fetch Error', e));
  };

  importPhrases = (language, platform) => {
    const { jsonStrings } = this.state;

    const allLanguages = ['sv', 'en', 'nb', 'da', 'fi', 'de', 'es'];

    const importData = jsonStrings.map((string) => {
      const translations = [];

      // if the language doesn't match you must still add the language object but without a content
      allLanguages.forEach((lang) => {
        if (lang === 'en') {
          translations.push({ lang, content: string.source || string.target });
        } else if (lang === language) {
          translations.push({ lang: language, content: string.target ? string.target : '' });
        } else {
          translations.push({ lang });
        }
      });

      return {
        identifier: `${platform}-${string.identifier}`,
        platform,
        translations,
        comment: string.comment ? string.comment : '',
        meta: string.meta ? { ...string.meta } : {},
      };
    });

    callApi(`${API_BASE_URL}/utils/phrases/import`,
      'POST',
      { 'Content-Type': 'application/json' },
      { importData, meta: { language, platform } }
    )
      .then((data) => {
        const itemCount = data.json.length;
        this.setState({ initialResource: { ...data.json }, resource: { ...data.json }, itemCount, fileName: '', disabledImport: true });
      });
  };

  // wraps FileReader in promises
  readUploadedFileAsText = (inputFile) => {
    const temporaryFileReader = new FileReader();

    return new Promise((resolve, reject) => {
      temporaryFileReader.onerror = () => {
        temporaryFileReader.abort();
        reject('Problem parsing input file.');
      };

      temporaryFileReader.onload = () => {
        resolve(temporaryFileReader.result);
      };
      temporaryFileReader.readAsText(inputFile);
    });
  };

  xliffHelper = (data, numFields, keys) => {
    let result;

    numFields.forEach((item, i) => {
      if (data.children[i] && data.children[i].name === item && data.children[i].children.length > 0) {
        result = { ...result,
          [item]: data.children[i].children[0][keys[i]],
        };
      }
    });

    result = {
      ...result,
      identifier: data.attributes.id,
    };
    return result;
  }

  traverseChildren = (data, language) => { // eslint-disable-line
    if (data.name === 'file') {
      return {
        file: {
          ...data.attributes,
          header: this.traverseChildren(data.children[0], language),
          body: this.traverseChildren(data.children[1], language),
        },
      };
    } else if (data.name === 'header') {
      return {
        attributes: { ...data.children[0].attributes },
      };
    } else if (data.name === 'trans-unit') {
      if (language === 'en') {
        return this.xliffHelper(data, ['source', 'note'], ['text', 'text']);
      }
      return this.xliffHelper(data, ['source', 'target', 'note'], ['text', 'text', 'text']);
    } else if (has(data, 'children')) {
      return this.traverseChildren(data.children, language);
    } else if (isArray(data)) {
      return data.map((child) => this.traverseChildren(child, language));
    }
  }

  xliffParser = (data, language) => this.traverseChildren(data, language)[0].map((obj) => {
    const { file: objFile } = obj; // rename it because I want to use the name file to deconstruct its contents

    const { header, body, ...file } = objFile;
    return body.map((transUnit) => {
      const result = {
        meta: {
          file,
          header: { ...header.attributes },
        },
        source: transUnit.source,
        comment: transUnit.note,
        identifier: `${file.original}@@@@${transUnit.identifier}`,
      };

      if (transUnit.target) {
        result.target = transUnit.target;
      }
      return result;
    });
  })

  androidParser = (data) =>
    data.map((string, i, arr) => {
      // ignore the item if it's a comment
      if (string.type === 'comment') {
        return undefined;
      }

      const result = {
        identifier: string.attributes.name,
        target: string.children[0].text,
      };

      // if the previous entry was a comment - add it to the current item
      if (i > 0 && arr[i - 1].type === 'comment') {
        result.comment = arr[i - 1].content;
      }

      return result;
    }).filter((item) => !!item) // get rid of empty 'undefined' entries


  handleUpload = async (event, platform) => {
    if (event.target.files) {
      const [file] = event.target.files;
      this.setState({ fileName: get(file, 'name') });
      console.log('platform', platform);
      console.log('file.type', file.type);

      try {
        let fileContents = await this.readUploadedFileAsText(file);
        fileContents = fileContents.replace(/(\r\n\t|\n|\r\t)/gm, '').replace(/>\s*/g, '>').replace(/\s*</g, '<'); // trim whitespace and line breaks
        if (platform === 'android' && file.type === 'text/xml') {
          const json = parseXml(fileContents, { preserveComments: true, preserveWhitespace: false });

          const androidJson = this.androidParser(json.children[0].children);

          this.setState({ jsonStrings: androidJson, disabledImport: false });
          return;
        } else if (platform === 'ios' && file.type.includes('xliff')) {
          const json = parseXml(fileContents);
          const iosJson = this.xliffParser(json, this.state.selectedLanguage);
          this.setState({ jsonStrings: flatten(iosJson), disabledImport: false });
          return;
        } else if (file.type === 'application/json') {
          const json = JSON.parse(fileContents);
          const keys = Object.keys(json);
          const result = [];
          keys.forEach((key) => {
            result.push({
              identifier: key,
              target: json[key],
            });
          });
          this.setState({ jsonStrings: result, disabledImport: false });
          return;
        }
        this.setState({ disabledImport: true }, () => this.props.showNotification('Wrong file for the platform', 'warning'));
      } catch (e) {
        console.log(e);
        this.setState({ fileName: '' });
        this.props.showNotification('Bad file format.', 'warning');
      }
    }
    this.setState({ fileName: '' });
  }

  toggleClass = ({ col, val }) => {
    if (val) {
      this.setState({ [col]: '' });
    } else {
      this.setState({ [col]: col }); // set the variable's value to be its own name
    }
  }

  handleCheckbox = () => {
    this.setState((prevState) => ({ checked: !prevState.checked }));
  }

  formatIdentifier = (identifier) => {
    let removedPrefix;
    removedPrefix = identifier.split(/-(.+)/, 2).slice(1).join(); // platform prefix
    removedPrefix = removedPrefix.split('@@@@'); // ios file prefix
    if (removedPrefix.length > 1) {
      removedPrefix = removedPrefix.slice(1).join().replace(/_/gi, ' ');
    } else {
      return removedPrefix.join().replace(/_/gi, ' ');
    }

    return removedPrefix;
  }

  pageForward = () => {
    const { pageSize, pageStart, itemCount } = this.state;
    if (pageStart + pageSize >= itemCount) {
      return;
    }
    const nextPage = pageStart + pageSize;
    this.setState({ pageStart: nextPage, currentPage: Math.ceil(nextPage / pageSize) + 1 });
  }

  pageBackward = () => {
    const { pageSize, pageStart } = this.state;
    if (pageStart <= 0 || pageStart - pageSize <= 0) {
      this.setState({ pageStart: 0, currentPage: 1 });
      return;
    }
    const prevPage = pageStart - pageSize;
    this.setState({ pageStart: prevPage, currentPage: Math.ceil(pageStart / pageSize) });
  }

  // value is pageSize
  handlePageSizeChange = (event, index, value) => {
    const { pageStart, itemCount } = this.state;
    const currentPage = Math.ceil((pageStart - 1) / value) + 1;

    this.setState({
      pageSize: value,
      totalPages: Math.ceil(itemCount / value),
      currentPage,
    });
  }

  handleReferenceLanguageChange = (event, index, value) => this.setState({ referenceLanguage: value });

  hydrate = () => {
    const { resource, referenceLanguage } = this.state;
    const { user: { languages }, user, property, showTitle } = this.props;
    let rows = [
      this.state.header,
    ];

    // add className here rather than componentWillMount to trigger re-renders
    rows = rows.map((arr) => arr.map((header) => {
      if (header.value === 'identifier') {
        return { ...header, className: this.state.toggleIdentifier };
      } else if (header.value === 'comments') {
        return { ...header, className: this.state.toggleComments };
      } else if (header.value === 'translatable') {
        return { ...header, className: this.state.toggleTranslatable };
      }
      return header;
    }));

    const newRows = range(0, this.state.itemCount).slice(this.state.pageStart, this.state.pageStart + this.state.pageSize)
      .map((id) => {
        let readOnly = resource[id].translatable ? resource[id].translatable : true;
        if (typeof readOnly === 'string') {
          readOnly = resource[id].translatable === 'true';
        }

        const properties = languages.map((lang) => {
          // the languages must always exist in the translations array so index can match something
          const index = resource[id] && resource[id][property].findIndex((p) => p && p.lang === lang); // resource = phrases, property = translations
          if (index === -1) {
            resource[id][property].push({ lang, content: '' });
          }

          const propObj = {
            readOnly: !readOnly,
            name: `${property}.${index}`,
            value: resource[id] && resource[id][property][index] ? resource[id][property][index].content : '',
            className: resource[id] && resource[id][property][index] && resource[id][property][index].content ? '' : 'translations-missing-translation',
          };

          return (propObj);
        });

        const referenceIndex = resource[id] && resource[id][property].findIndex((p) => p && p.lang === referenceLanguage);

        let titleIndex;
        let title;


        if (resource[id] && resource[id].title) {
          titleIndex = resource[id] && resource[id].title.findIndex((p) => p && p.lang === referenceLanguage);
          title = showTitle ? [{ name: 'title', value: titleIndex !== -1 && resource[id] && resource[id].title[titleIndex] ? resource[id].title[titleIndex].content : '', readOnly: true }] : [];
        } else {
          titleIndex = resource[id] && resource[id].translations.findIndex((p) => p && p.lang === referenceLanguage);
          title = showTitle ? [{ name: 'title', value: titleIndex !== -1 && resource[id] && resource[id].translations[titleIndex] ? resource[id].translations[titleIndex].content : '', readOnly: true }] : [];
        }

        return ([
          { readOnly: true, value: id + 1 }, // display array index 0 as 1 in the grid
          ...title,
          {
            readOnly: true,
            value: resource[id].identifier && this.formatIdentifier(resource[id].identifier),
            className: this.state.toggleIdentifier,
          },
          {
            value: resource[id].translatable,
            name: 'translatable',
            component: (
              <Select
                key={resource[id].identifier}
                autoFocus
                openOnFocus
                placeholder=""
                options={[{ value: true, label: 'true' }, { value: false, label: 'false' }]}
                value={resource[id].translatable}
                onChange={((val) => {
                  if (!val) return;
                    const { resource } = this.state; // eslint-disable-line
                  resource[id].translatable = val.value;
                  this.setState({ [`checkbox-${id}`]: val.value, resource });
                })}
              />
            ),
            className: `${this.props.user.superUser ? '' : 'hideTranslatables'} ${this.state.toggleTranslatable}`,
          },
          {
            readOnly: !isSuperUser(user),
            value: resource[id].comment || this.props.resource === 'products' ? resource[id].internalName : '',
            name: 'comment',
            className: this.state.toggleComments,
          },
          {
            name: `${property}.${referenceIndex}`,
            value: resource[id] && resource[id][property][referenceIndex] ? resource[id][property][referenceIndex].content : '',
            readOnly: true,
          },
          ...properties,
        ]);
      });

    return [...rows, ...newRows];
  };

  render() {
    const {
      props,
    } = this;
    const { platform } = has(this.props, 'filter') ? this.props.filter : '';
    const { showNotification, property, translate, user } = props;
    const { toggleIdentifier, toggleComments, toggleTranslatable } = this.state;
    return (
      <div>
        {
          this.props.filter && this.props.user.superUser &&
          <ExportComponent
            disabled={this.state.disabledImport}
            exportFn={this.exportPhrases}
            handleUpload={this.handleUpload}
            importFn={this.importPhrases}
            onChange={this.onLanguageChange}
            platform={platform}
            fileName={this.state.fileName}
            translate={props.translate}
            onLanguageChangeCb={this.onLanguageChangeCb}
            user={this.props.user}
          />
        }
        <div style={styles.buttonParent}>
          <div className="translations-toggleButtons">
            <FlatButton onClick={() => this.toggleClass({ col: 'toggleIdentifier', val: toggleIdentifier })}>
              {toggleIdentifier ? translate('show.item', { item: 'ID' }) : translate('hide.item', { item: 'ID' })}
            </FlatButton>
            {
              user && isSuperUser(user) && (
                <FlatButton onClick={() => this.toggleClass({ col: 'toggleTranslatable', val: toggleTranslatable })}>
                  {toggleTranslatable ? translate('show.item', { item: translate('translations.translatable') }) : translate('hide.item', { item: translate('translations.translatable') })}
                </FlatButton>
              )
            }
            <FlatButton onClick={() => this.toggleClass({ col: 'toggleComments', val: toggleComments })}>
              {toggleComments ? translate('show.item', { item: translate('comments') }) : translate('hide.item', { item: translate('comments') })}
            </FlatButton>
          </div>
          <div>
            <div className="translations-select-fields--div">
              <SelectField
                floatingLabelText={translate('translations.referenceLanguage')}
                onChange={this.handleReferenceLanguageChange}
                value={this.state.referenceLanguage}
              >
                <MenuItem value="sv" primaryText={translate('languages.sv')} />
                <MenuItem value="fi" primaryText={translate('languages.fi')} />
                <MenuItem value="nb" primaryText={translate('languages.nb')} />
                <MenuItem value="en" primaryText={translate('languages.en')} />
                <MenuItem value="da" primaryText={translate('languages.da')} />
              </SelectField>
              <SelectField
                floatingLabelText={translate('perPage')}
                value={this.state.pageSize}
                onChange={this.handlePageSizeChange}
              >
                <MenuItem value={this.state.itemCount} primaryText={translate('all')} />
                <MenuItem value={50} primaryText="50" />
                <MenuItem value={100} primaryText="100" />
                <MenuItem value={200} primaryText="200" />
              </SelectField>
            </div>
            <div style={styles.pageButtonParent}>
              <FlatButton onClick={this.pageBackward}>
                {translate('previous.item', { item: translate('academy.page') })}
              </FlatButton>
              <span>{`${this.state.currentPage}/${this.state.totalPages}`}</span>
              <FlatButton onClick={this.pageForward}>
                {translate('next.item', { item: translate('academy.page') })}
              </FlatButton>
            </div>
          </div>
        </div>
        <Datasheet
          data={this.hydrate()}
          valueRenderer={(cell) => typeof cell.value === 'boolean' ? cell.value === true ? 'true' : 'false' : cell.value}
          onContextMenu={(e, cell) => cell.readOnly ? e.preventDefault() : null}
          onCellsChanged={(changes) => {
            const { resource, pageStart } = this.state;
            changes.forEach(({ cell, row, value }) => {
              // - 1 because we set the displayed value to be + 1 in hydrate()
              if (!resource[(row - 1) + pageStart]) resource[(row - 1) + pageStart] = {};
              let data = resource[(row - 1) + pageStart];
              if (cell.name === 'comment') {
                data.comment = value;
              } else if (cell.name === 'translatable') {
                data.translatable = String(cell.value);
              } else {
                data = set(data, cell.name, { ...get(data, cell.name), content: value });
              }
              const id = has(data, 'id') ? data.id : data._id;
              console.log('data', id, data, cell);

              restClient(UPDATE, props.resource, { id, data })
                .then((res) => {
                  console.log('res.data', res.data, data.id);
                  resource[(row - 1) + pageStart] = { ...res.data };
                  this.setState({ resource });
                  showNotification(`${property} updated`);
                })
                .catch(() => {
                  showNotification(`Error: ${property} not updated. Reload and try again.`, 'warning');
                });
            });

            this.setState({ resource });
          }}
        />
      </div>
    );
  }
};

export default TranslationComponent;
